<div class="smartphoto-damage-estimation-list">
  <form [formGroup]="selectForm">
    <bdeo-select
      [options]="selectOptions"
      formControlName="selector"
      type="form"
      size="medium"
      ngDefaultControl
      (change)="updateDamageList()"
    >
    </bdeo-select>
  </form>

  @if (selectedOption === 'claims') {
    <app-smartphoto-damage-estimation-card
      data-test-id="paint-labour-price-data"
      [cardInfo]="labourPriceFields"
      (onEditButtonClick)="handleEditPriceButtonClicked()"
    ></app-smartphoto-damage-estimation-card>
    <bdeo-divider type="horizontal"></bdeo-divider>
  }

  @for (fields of selectedDamagesFields; track $index) {
    <app-smartphoto-damage-estimation-card
      [cardInfo]="fields"
      [attr.data-test-id]="fields.title"
      (onActionsButtonClick)="handleActionButtonClicked($event)"
      (onEditButtonClick)="handleEditButtonClicked($event)"
    ></app-smartphoto-damage-estimation-card>
    @if ($index < selectedDamages.length - 1) {
      <bdeo-divider type="horizontal"></bdeo-divider>
    } @else {
      @if (showAddButton) {
        <bdeo-divider type="horizontal"></bdeo-divider>
      }
    }
  }

  <div class="smartphoto-damage-estimation-list__add-button">
    @if (showAddButton) {
      <bdeo-button
        type="secondary"
        skin="ghost"
        icon="plus-plus"
        [text]="'brokers:add_damages.add_damage_button' | i18nextEager"
        (click)="add()"
        [attr.data-test-id]="'add-damage-button'"
        [disabled]="!(canAddNewDamage$ | async)"
      >
      </bdeo-button>
    }
  </div>
</div>

@if (smartphoto) {
  <app-smartphoto-damage-estimation-drawer
    [customPartsSelector]="customPartsSelector"
    [alreadyAddedParts]="getAlreadyAddedParts()"
    [damage]="drawerDamage"
    (damageSaved)="handleDamageAdded($event)"
    (close)="drawerDamage = undefined"
  ></app-smartphoto-damage-estimation-drawer>

  <app-smartphoto-damage-estimation-price-drawer></app-smartphoto-damage-estimation-price-drawer>
}
